import React from 'react';
import { CheckCircle, Target, Heart, Scale } from 'lucide-react';
import { Card } from '../components/ui/card';
import { whyChooseUs } from '../mockData';

const About = () => {
  return (
    <div className="min-h-screen bg-[#1a1c1b] pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1c1b] via-[#2a2c2b] to-[#1a1c1b]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6">
              ABOUT
              <span className="block text-[#d9fb06]">MAC LAW ADVOCATES</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
              A trusted legal partner committed to delivering professional, client-focused legal solutions with integrity and excellence.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            <div>
              <div className="inline-block bg-[#3f4816]/30 border border-[#d9fb06]/20 rounded-full px-4 py-2 mb-6">
                <span className="text-[#d9fb06] text-sm font-bold uppercase tracking-wide">Our Mission</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-black text-white mb-6">
                Providing Excellence in Legal Services
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                At MAC Law Advocates, we are dedicated to providing comprehensive legal solutions that protect our clients' interests and rights. Based in Nairobi, we serve individuals and businesses with professionalism, integrity, and unwavering commitment.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                Our approach combines deep legal expertise with personalized service, ensuring every client receives the attention and results they deserve.
              </p>
            </div>

            <div className="bg-[#302f2c] border border-[#3f4816] p-10 rounded-lg">
              <h3 className="text-2xl font-bold text-[#d9fb06] mb-6">Our Core Values</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <Scale className="w-6 h-6 text-[#d9fb06] mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-white font-bold mb-1">Integrity</h4>
                    <p className="text-gray-400 text-sm">Upholding the highest ethical standards in all our dealings</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <Target className="w-6 h-6 text-[#d9fb06] mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-white font-bold mb-1">Excellence</h4>
                    <p className="text-gray-400 text-sm">Delivering superior legal services and outcomes</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <Heart className="w-6 h-6 text-[#d9fb06] mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-white font-bold mb-1">Client Focus</h4>
                    <p className="text-gray-400 text-sm">Prioritizing your needs and goals above all else</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 text-[#d9fb06] mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="text-white font-bold mb-1">Professionalism</h4>
                    <p className="text-gray-400 text-sm">Maintaining the highest standards of legal practice</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-[#302f2c]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">WHY CHOOSE US</h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              What sets MAC Law Advocates apart
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {whyChooseUs.map((reason) => (
              <Card key={reason.id} className="bg-[#1a1c1b] border-[#3f4816] p-8 hover:border-[#d9fb06] transition-all duration-300">
                <h3 className="text-2xl font-bold text-[#d9fb06] mb-4">{reason.title}</h3>
                <p className="text-gray-400 text-base leading-relaxed">{reason.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">OUR LOCATION</h2>
            <p className="text-xl text-gray-400">
              Visit us at our Nairobi office
            </p>
          </div>
          <div className="bg-[#302f2c] border border-[#3f4816] rounded-lg p-8 max-w-3xl mx-auto">
            <p className="text-white text-lg mb-2 font-semibold">MAC Law Advocates</p>
            <p className="text-gray-400 mb-2">Legal Aid Center, Lenana Road</p>
            <p className="text-gray-400 mb-4">Nairobi, Kenya</p>
            <p className="text-[#d9fb06] font-semibold">Phone: +254 726 404 984</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
